import React, { useRef, useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { useNavigate } from "react-router-dom";
const MotherPlant = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/operationsReports");
  };

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [regionId, setRegionId] = useState(0);
  const [regionData, setRegionData] = useState([]);
  const [data, setData] = useState([]);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const { sendRequest: getprocurementData } = useHttp();
  const { sendRequest: getEmp } = useHttp();
  const { sendRequest: getRegion } = useHttp();

  const [cropList, setCropList] = useState([]);
  const [cropId, setCropId] = useState("");
  const [varietyData, setVarietyData] = useState([]);
  const [allVarietyData, setAllVarietyData] = useState([]);
  const [varietyId, setVarietyId] = useState(0);
  const [varietyList, setVarietyList] = useState([]);
  const [nurseryList, setNurseryList] = useState([]);

  const [warehousesList, setWarehousesList] = useState([]);
  const [sectionList, setSectionList] = useState([]);
  const [allSectionData, setAllSectionData] = useState([]);
  const [warehousesId, setWarehousesId] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [selectedNursery, setSelectedNursery] = useState("");

  useEffect(() => {
    getprocurementData(
      {
        url: `/api/NuseryWithAllTypeListCreateView/?orgId=${localStorage.getItem(
          "orgId"
        )} && createdBy=${localStorage.getItem("id")}`,
      },
      (res) => setWarehousesList(res)
    );

    getprocurementData(
      { url: `/api/getCropMaster/?orgId=${localStorage.getItem("orgId")}` },
      (res) => setCropList(res)
    );

    getprocurementData(
      { url: `/api/getVarietyMaster/?orgId=${localStorage.getItem("orgId")}` },
      (res) => {
        setAllVarietyData(res);
        setVarietyList(res);
      }
    );
  }, []);

  const { sendRequest: getNurseryData } = useHttp();
  useEffect(() => {
    getNurseryData(
      {
        url: `/api/warehouses/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        console.log("setNurseryList", res);
        setWarehousesList(res || []);
      }
    );
  }, [getNurseryData]);

  const handleNurseryChange = (e) => {
    setSelectedNursery(e.target.value);
  };
  const { sendRequest: getCropVarietyData } = useHttp();
  useEffect(() => {
    getCropVarietyData(
      {
        url: `/api/farmerCropVarietyForSelection/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setCropList(data.cropList || []);
        setAllVarietyData(data.varietylist || []);
        setVarietyList(data.varietylist || []);
      }
    );
  }, [getCropVarietyData]);

  const handleCropChange = (selectedCropId) => {
    setCropId(selectedCropId); // directly store as string
    setVarietyId("");

    if (selectedCropId) {
      const filteredVarieties = allVarietyData.filter(
        (v) => String(v.cropId) === selectedCropId
      );
      setVarietyList(filteredVarieties);
    } else {
      setVarietyList(allVarietyData);
    }
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  const d = new Date();
  d.setDate(d.getDate() - 90);
  const [selectedFromDate, setSelectedFromDate] = useState(
    d.toISOString().slice(0, 10)
  );
  const [selectedToDate, setSelectedToDate] = useState(currentDate);

  const handleFDateChange = (e) => setSelectedFromDate(e.target.value);
  const handleTDateChange = (e) => setSelectedToDate(e.target.value);

  const [showDateFilter, setShowDateFilter] = useState(false);
  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const fillprocurementData = () => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (cropId > 0) {
      urlfilter = urlfilter + `&cropId=${cropId}`;
    }

    if (varietyId > 0) {
      urlfilter = urlfilter + `&varietyId=${varietyId}`;
    }
    if (selectedNursery > 0) {
      urlfilter = urlfilter + `&nurseryId=${selectedNursery}`;
    }

    getprocurementData(
      {
        url: `/api/getMotherPlantReport/?orgId=${localStorage.getItem(
          "orgId"
        )}${urlfilter} `,
        method: "GET",
      },
      (res) => setData(res)
    );
  };

  useEffect(() => {
    fillprocurementData(0, 0);
  }, []);

  const fieldsToExport = [
    "fieldOperationDate",
    "docNo",
    "stationName",
    "executiveName",
    "cropName",
    "varietyName",
    "batch",
    "ageDays",
    "farmerStatus",
    "yield",
    "insectDiseasePestName",
    "areaName",
    "state",
    "village",
    "country",
    "fieldOperationDescription",
  ];

  const customHeaders = [
    "Date",
    "Doc No",
    "Nursery Name",
    "Executive",
    "Crop",
    "Variety Name",
    "Batch",
    "Age (days)",
    "Plant Health",
    "Yield (Kg/Ha)",
    "Disease/Insect/Pest Observed",
    "Address",
    "State",
    "Village",
    "Country",
    "Description",
  ];

  const handleExportExcel = () => {
    convertToExcel(
      data,
      fieldsToExport,
      "CropObservationReport.xlsx",
      customHeaders
    );
  };

  const EmployeeDetail = (region) => {
    let urlfilter = "";
    if (region > 0) urlfilter += `&regionId=${region}`;
    getEmp(
      {
        url: `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter}`,
      },
      (res) => setEmployeeData(res)
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, []);

  useEffect(() => {
    getRegion(
      {
        url: `/api/procurementRegionList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => setRegionData(res.data)
    );
  }, []);

  return (
    <div className="content-wrapper">
      <div className="row mx-2 mt-3">
        <div className="col-md-8">
          <label className="card-title mx-3">Mother Plant Detail Reports</label>
        </div>
        <div className="col-md-4 text-right mt-3">
          <button
            type="button"
            className="btn btn-tool"
            data-card-widget="remove"
            onClick={handleButtonClick}
          >
            <i className="fas fa-times" />
          </button>
        </div>
      </div>

      {/* Filter Section */}
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            {/* Nursery Name */}
            <div className="col-md-3">
              <label>Nursery Name</label>
              <select
                className="form-control"
                value={selectedNursery}
                onChange={handleNurseryChange}
              >
                <option value="">Select</option>
                {warehousesList.length > 0 &&
                  warehousesList.map((warehouse) => (
                    <option
                      key={warehouse.nurseryId}
                      value={warehouse.nurseryId}
                    >
                      {warehouse.name}
                    </option>
                  ))}
              </select>
            </div>

            {/* Crop Name */}
            <div className="col-md-3">
              <div className="form-group">
                <label>Crop Name</label>
                <select
                  className="form-control"
                  value={cropId}
                  onChange={(e) => handleCropChange(e.target.value)} 
                >
                  <option value="">Select</option>
                  {cropList.map((crop) => (
                    <option key={crop.cropId}>
                      {crop.cropName}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Variety Name */}
            <div className="col-md-3">
              <div className="form-group">
                <label>Variety Name</label>
                <select
                  className="form-control"
                  value={varietyId}
                  onChange={(e) => setVarietyId(e.target.value)}
                >
                  <option value="">Select</option>
                  {varietyList.map((variety) => (
                    <option key={variety.varietyId} value={variety.varietyId}>
                      {variety.varietyName}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Apply Date Filter */}
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor="date_filter">Apply Date Filter</label>
                <select
                  id="date_filter"
                  className="form-control"
                  ref={(el) => (frmRef.current["date_filter"] = el)}
                  onChange={handleDateFilterChange}
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
            </div>

            {/* Conditional From/To Date inputs */}
            {showDateFilter && (
              <>
                <div className="col-md-2">
                  <div className="form-group">
                    <label htmlFor="from_date">From Date</label>
                    <input
                      type="date"
                      id="from_date"
                      className="form-control"
                      max={currentDate}
                      value={selectedFromDate}
                      onChange={handleFDateChange}
                    />
                  </div>
                </div>

                <div className="col-md-2">
                  <div className="form-group">
                    <label htmlFor="to_date">To Date</label>
                    <input
                      type="date"
                      id="to_date"
                      className="form-control"
                      max={currentDate}
                      value={selectedToDate}
                      onChange={handleTDateChange}
                    />
                  </div>
                </div>
              </>
            )}

            {/* Submit Button */}
            <div className="col-md-2 text-right">
              <div className="form-group">
                <label>&nbsp;</label>
                <button
                  className="form-control btn btn-primary"
                  onClick={() => fillprocurementData(employeeId, regionId)}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
        <h5>Please select the parameters to get the desired result</h5>
        <hr />
      </section>

      {/* Export + Table */}
      <section className="content">
        <div className="container-fluid">
          <div className="text-right my-2">
            <button className="btn btn-warning" onClick={handleExportExcel}>
              <i className="fas fa-file-excel"></i> Export Excel
            </button>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body" style={{ padding: "0.4rem" }}>
                  <table className="table table-bordered table-sm text-center">
                    <thead>
                      <tr className="tableheaderrowview">
                        {customHeaders.map((head, i) => (
                          <th key={i}>{head}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.length > 0 ? (
                        currentItems.map((itm, i) => (
                          <tr key={i} className="tablerowview">
                            <td>{itm.date}</td>
                            <td>{itm.docNo || "-"}</td>
                            <td>{itm.nurseryName}</td>
                            <td>{itm.createdByName}</td>
                            <td>{itm.cropName}</td>
                            <td>{itm.varietyName}</td>
                            <td>{itm.batchNo || "-"}</td>
                            <td>{itm.ageDays || "-"}</td>
                            <td>{itm.plantHealth}</td>
                            <td>{itm.yieldPerKg || "-"}</td>
                            <td>{itm.insectDiseasePestName}</td>
                            <td>{itm.address}</td>
                            <td>{itm.state || "-"}</td>
                            <td>{itm.village || "-"}</td>
                            <td>{itm.country || "India"}</td>
                            <td>{itm.description}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={16}>No Records Found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="card-footer clearfix">
                  <Pagination
                    totalItems={data.length}
                    itemsPerPage={itemsPerPage}
                    onPageChange={paginate}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MotherPlant;
